import { render, staticRenderFns } from "./PricingHeader.vue?vue&type=template&id=60c0445d&scoped=true"
var script = {}
import style0 from "./PricingHeader.vue?vue&type=style&index=0&id=60c0445d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0445d",
  null
  
)

export default component.exports